import { z } from 'zod';

/**
 * The operating company behind a deployment — `brand.legalEntity`.
 *
 * Four named facts rather than a paragraph (P10.3a, "no setting is prose"), and
 * none translatable: a registered legal name has one spelling, and translating
 * it would misstate who the contract is with. Every field may be empty — an
 * unconfigured deployment publishes blanks and a client draws nothing for them.
 */
export const BrandLegalEntitySchema = z
  .object({
    name: z.string().max(200),
    registrationNumber: z.string().max(100),
    address: z.string().max(500),
    country: z.string().max(100),
  })
  .strict();

export type BrandLegalEntity = z.infer<typeof BrandLegalEntitySchema>;

/** The registry's coded default, and what a client reads until the payload lands. */
export const EMPTY_BRAND_LEGAL_ENTITY: Readonly<BrandLegalEntity> = Object.freeze({
  name: '',
  registrationNumber: '',
  address: '',
  country: '',
});
